import React, { useEffect, useState } from "react";
import {
    Box, Typography, Paper, Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow, IconButton,
    TextField, TablePagination, Dialog, DialogTitle,
    DialogContent, DialogActions, Button
} from "@mui/material";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import { db } from "../../firebase";
import {
    collection, onSnapshot, deleteDoc, doc,
    updateDoc, query, orderBy
} from "firebase/firestore";

function Boldertrips() {

    const navigate = useNavigate();

    const [trips, setTrips] = useState([]);
    const [search, setSearch] = useState("");

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);

    const [selectedDate, setSelectedDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [imageOpen, setImageOpen] = useState(false);
    const [selectedImages, setSelectedImages] = useState({ tarePhotos: [], grossPhotos: [] });

    // ================= FETCH DATA =================
    useEffect(() => {

        const q = query(
            collection(db, "trips"),
            orderBy("grossDate", "desc")
        );

        const unsub = onSnapshot(q, (snapshot) => {

            const start = new Date(selectedDate);
            start.setHours(0, 0, 0, 0);

            const end = new Date(selectedDate);
            end.setHours(23, 59, 59, 999);

            const data = snapshot.docs
                .map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }))
                .filter(trip => {

                    // ✅ FILTER BOLDER PRODUCT
                    const hasBolder = trip.products?.some(p =>
                        (p.productName || "").toLowerCase().includes("bolder")
                    );

                    if (!hasBolder) return false;

                    // ✅ GET DATE (tare OR gross)
                    const tripDate = trip.grossDate
                        ? new Date(trip.grossDate.seconds * 1000)
                        : trip.grossDate
                            ? new Date(trip.grossDate.seconds * 1000)
                            : null;

                    if (!tripDate) return false;

                    return tripDate >= start && tripDate <= end;

                });

            setTrips(data);

        });

        return () => unsub();

    }, [selectedDate]);

    // ================= DELETE =================
    const handleDelete = async (id) => {

        Swal.fire({
            title: "Delete Trip?",
            text: "This record will be permanently deleted.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            confirmButtonText: "Yes Delete"
        }).then(async (result) => {

            if (result.isConfirmed) {
                await deleteDoc(doc(db, "trips", id));
                Swal.fire("Deleted!", "Trip removed successfully", "success");
            }

        });
    };

    // ================= VIEW IMAGES =================
    const handleViewImages = (trip) => {
        setSelectedImages({
            tarePhotos: trip.tarePhotos || [],
            grossPhotos: trip.grossPhotos || []
        });
        setImageOpen(true);
    };

    // ================= SEARCH =================
    const filteredTrips = trips.filter((trip) =>
        JSON.stringify(trip).toLowerCase().includes(search.toLowerCase())
    );

    return (
        <Box sx={{ bgcolor: '#f4f6f8', minHeight: '100vh', p: 1 }}>

            <Paper sx={{ p: 2 }}>

                {/* HEADER */}
                <Box display="flex" justifyContent="space-between" mb={2}>

                    <Typography variant="h6">
                        Bolder Trips List
                    </Typography>

                    <Box display="flex" gap={1}>
                        <TextField
                            size="small"
                            label="Search"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />

                        {/* ✅ DATE FILTER */}
                        <TextField
                            type="date"
                            size="small"
                            label="Date"
                            InputLabelProps={{ shrink: true }}
                            value={selectedDate}
                            onChange={(e) => setSelectedDate(e.target.value)}
                        />
                    </Box>
                </Box>

                {/* TABLE */}
                <TableContainer>
                    <Table size="small">

                        <TableHead>
                            <TableRow sx={{ background: "#f5f5f5" }}>
                                <TableCell>SR</TableCell>
                                <TableCell>Ticket</TableCell>
                                <TableCell>Party</TableCell>
                                <TableCell>Vehicle</TableCell>
                                <TableCell>Product</TableCell>
                                <TableCell>Net Wt</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredTrips
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map((row, index) => {

                                    const totalSale =
                                        row.products?.reduce(
                                            (sum, p) => sum + (Number(p.amount) || 0),
                                            0
                                        ) || 0;

                                    return (
                                        <TableRow key={row.id} hover>

                                            <TableCell>
                                                {page * rowsPerPage + index + 1}
                                            </TableCell>

                                            <TableCell>{row.ticketNo}</TableCell>

                                            <TableCell>{row.customerName}</TableCell>

                                            <TableCell>{row.vehicleNo}</TableCell>

                                            <TableCell>
                                                {row.products?.map((p, i) => (
                                                    <Typography key={i}>
                                                        {p.productName}
                                                    </Typography>
                                                ))}
                                            </TableCell>

                                            {/* <TableCell>
                                                {row.products?.map((p, i) => (
                                                    <Typography key={i}>
                                                        {p.qty}
                                                    </Typography>
                                                ))}
                                            </TableCell>

                                            <TableCell>
                                                ₹ {row.totalAmount || totalSale}
                                            </TableCell> */}

                                            <TableCell>{row.netWeight}</TableCell>


                                            <TableCell>
                                                {row.grossDate ?
                                                    new Intl.DateTimeFormat('en-GB', {
                                                        day: '2-digit',
                                                        month: '2-digit',
                                                        year: 'numeric',
                                                        hour: '2-digit', // Uncomment these if you want time too
                                                        minute: '2-digit',
                                                        second: '2-digit'
                                                    }).format(row.grossDate.toDate())
                                                    : ""
                                                }
                                            </TableCell>

                                            <TableCell>

                                                <IconButton
                                                    onClick={() => navigate(`/edit-trip/${row.id}`)}
                                                >
                                                    <EditIcon />
                                                </IconButton>

                                                <IconButton
                                                    onClick={() => handleViewImages(row)}
                                                >
                                                    📷
                                                </IconButton>

                                                <IconButton
                                                    color="error"
                                                    onClick={() => handleDelete(row.id)}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>

                                            </TableCell>

                                        </TableRow>
                                    );
                                })}
                        </TableBody>

                    </Table>
                </TableContainer>

                <TablePagination
                    component="div"
                    count={filteredTrips.length}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => {
                        setRowsPerPage(parseInt(e.target.value, 10));
                        setPage(0);
                    }}
                />

            </Paper>

            {/* IMAGE VIEW */}
            <Dialog open={imageOpen} onClose={() => setImageOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Trip Photos</DialogTitle>
                <DialogContent>

                    <Typography fontWeight="bold">Tare Photos</Typography>
                    <Box display="flex" gap={1} flexWrap="wrap">
                        {selectedImages.tarePhotos.map((url, i) => (
                            <img key={i} src={url} width={200} />
                        ))}
                    </Box>

                    <Typography fontWeight="bold" mt={2}>Gross Photos</Typography>
                    <Box display="flex" gap={1} flexWrap="wrap">
                        {selectedImages.grossPhotos.map((url, i) => (
                            <img key={i} src={url} width={200} />
                        ))}
                    </Box>

                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setImageOpen(false)}>Close</Button>
                </DialogActions>
            </Dialog>

        </Box>
    );
}

export default Boldertrips;